import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Assetgraphanddata = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("others");

  const handleTabClick = (tab) =>
    setActiveTab(tab.toLowerCase().replace("&", "").replace(/\s/g, ""));

  const tabs = [
    { key: "financial", label: t("asset.tabs.financial") ,to:"/financial"},
    { key: "energymaterial", label: t("asset.tabs.energymaterial") ,to:"/energyandmaterial"},
    { key: "transportation", label: t("asset.tabs.transportation") ,to:"/transport"},
    { key: "food", label: t("asset.tabs.food") ,to:"/food"},
    { key: "others", label: t("asset.tabs.others"),to:"/" },
  ];

  const activeTabRoute = tabs.find(tab => tab.key === activeTab)?.to;

  return (
    <div className="w-full px-2 py-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between">
        {/* Image Placeholder */}
        <div className="w-full md:w-1/2 flex items-center">
          <img
            src="assets/piechart.webp"
            alt={t("asset.imageAlt")}
            className="w-[30rem] h-auto object-contain"
          />
        </div>

        {/* Content Section */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 px-4 lg:px-0">
          <h2 className="text-4xl font-semibold text-gray-900 mb-4">
            {t("asset.heading.line1")} <br />
            {t("asset.heading.line2")}
          </h2>

          {/* Tabs */}
          <div className="flex flex-wrap gap-2 mb-4">
            {tabs.map(({ key, label }) => (
              <button
                key={key}
                onClick={() => handleTabClick(key)}
                className={`px-10 py-2 border border-black rounded-lg text-sm ${
                  activeTab === key ? "bg-gray-900 text-white" : "bg-transparent text-black"
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="h-[0.1em] w-full my-8 bg-black"></div>

          {/* Content Display */}
          <div>
            <div className="flex items-center justify-between mb-4">
              <p className="text-lg flex items-center gap-3 font-semibold text-gray-700">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1.18359"
                    width="16"
                    height="16"
                    rx="8"
                    fill="#6986BA"
                    stroke="#221F20"
                  />
                </svg>
                <span>{t(`asset.content.${activeTab}.title`)}</span>
              </p>
              <Link
                to={activeTabRoute}
                className="flex text-blue-600 font-semibold hover:underline items-center"
              >
                {t("asset.readMore")} →
              </Link>
            </div>
            <p className="text-gray-600">
              {t(`asset.content.${activeTab}.description`)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assetgraphanddata;
